import { AuthReducerModal } from "../../store/slices/initialState";
import services from "../../Constant/service";
import endpoint from "../../Constant/endpoint";
import {
  createSlice,
  createAsyncThunk,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";
const initialState = new AuthReducerModal();

const cxoSlice = createSlice({
  name: "cxoSlice",
  initialState,
  reducers: {
    set: (state, action) => ({ ...state, ...action.payload }),
    loader: (state, action) => ({ ...state, isLoader: action.payload }),
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending, (state) => ({ ...state, isLoader: true }))
      .addMatcher(isFulfilled, (state, action) => {
        const actionName = action.type.split("/")[1];
        const dynamicKey = `${actionName}Response`;
        return {
          ...state,
          isLoader: false,
          [dynamicKey]: action.payload,
        };
      })
      .addMatcher(isRejected, (state) => ({ ...state, isLoader: false }));
  },
});

export const getTransactionDetails = createAsyncThunk(
  "ageGroup/getTransactionDetails",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getTransactionDetails,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSourceWiseAnalysis = createAsyncThunk(
  "ageGroup/getSourceWiseAnalysis",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getSourceWiseAnalysis,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCouponTypeList = createAsyncThunk(
  "admin/getCouponTypeList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.cxo.getCouponTypeList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getStateWiseAnalysis = createAsyncThunk(
  "ageGroup/getStateWiseAnalysis",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getStateWiseAnalysis,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getProductWiseRevenue = createAsyncThunk(
  "cxo/getProductWiseRevenue",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getProductWiseRevenue,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getAllSourceLeads = createAsyncThunk(
  "cxo/getAllSourceLeads",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getAllSourceLeads,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getSourceWiseUserCount = createAsyncThunk(
  "cxo/getSourceWiseUserCount",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getSourceWiseUserCount,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getStateWiseUserCount = createAsyncThunk(
  "cxo/getStateWiseUserCount",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getStateWiseUserCount,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getSourceWiseRevenueAnalysis = createAsyncThunk(
  "cxo/getSourceWiseRevenueAnalysis",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getSourceWiseRevenueAnalysis,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSellingSourceWiseAnalysis = createAsyncThunk(
  "cxo/getSellingSourceWiseAnalysis",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getSellingSourceWiseAnalysis,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getStockAnalysis = createAsyncThunk(
  "cxo/getStockAnalysis",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.cxo.getStockAnalysis,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          errorCallback(error);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const { set, loader, reset } = cxoSlice.actions;
export default cxoSlice.reducer;
